import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from "@material-ui/core/Tooltip";
import GetAppIcon from "@material-ui/icons/GetApp";
import { EXPORT_NETSPACE_HOSTS_CSV } from "./NetSpaceConstant";
import ExportCsvConfirmPopup from "./ExportCsvConfirmPopup";

function NetSpaceExportButton() {
  const dispatch = useDispatch();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const isLoading = useSelector((state) => state.NetspaceReducer.loader);

  const handleIconClick = () => {
    setIsConfirmOpen(true);
  };

  const handleConfirmExport = () => {
    dispatch({
      type: EXPORT_NETSPACE_HOSTS_CSV,
    });
  };

  return (
    <>
      <Tooltip title="Export to CSV">
        <span>
          <IconButton
            size="small"
            onClick={handleIconClick}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={20} /> : <GetAppIcon />}
          </IconButton>
        </span>
      </Tooltip>

      <ExportCsvConfirmPopup
        open={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirmExport}
      />
    </>
  );
}

export default NetSpaceExportButton;